import {
   ApiResponse,
   createApiRequest,
   Header,
   getHeaderFromSessionStorage,
} from "@/api"
import { API_URL, Endpoints } from "@/constants/endpoints"
import { HttpMethods } from "@/constants/globals"
import { BaseUser, UserRole, UserStatus } from "@/types/user"

export interface UserRequest extends BaseUser {
   phone: {
      prefix: string
      number: string
   }
   role: UserRole
   newToken?: boolean
}

export interface UsersResponse extends UserRequest {
   id: string
   status: UserStatus
}

export async function requestUsers(
   header: Header
): Promise<ApiResponse<UsersResponse[]>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.USERS}`,
      HttpMethods.GET,
      null,
      getHeaderFromSessionStorage(header)
   )
   return response
}

export async function requestCreateUser(
   header: Header,
   userData: UserRequest,
   headerId?: string
): Promise<ApiResponse<UsersResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.ADD_USER}`,
      HttpMethods.POST,
      userData,
      headerId
         ? {
              headers: {
                 [header]: headerId,
              },
           }
         : getHeaderFromSessionStorage(header)
   )
   return response
}

export async function requestUpdateUser(
   header: Header,
   userId: string,
   userData: UserRequest
): Promise<ApiResponse<UsersResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.USERS}${userId}/`,
      HttpMethods.PATCH,
      { ...userData },
      getHeaderFromSessionStorage(header)
   )
   return response
}

export async function requestDeleteUser(
   header: Header,
   userId: string
): Promise<ApiResponse<void>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.USERS}${userId}/`,
      HttpMethods.DELETE,
      null,
      getHeaderFromSessionStorage(header)
   )
   return response
}
